import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'
import { useActivateContentsquareExperiment } from 'contentsquare'

import { EXPERIMENT_NAME_CONTACT_PAGE_ACCOUNT_MANAGEMENT_DIALOG } from '../../../experiments/model/EXPERIMENT_NAME'

import { useAccountManagementDialogContext } from './AccountManagementDialogContext'
import { DynamicAccountManagementDialogContent } from './DynamicAccountManagementDialogContent'

export const AccountManagementDialog: FC = () => {
  const { dialogControls, selectedContent } =
    useAccountManagementDialogContext()

  useActivateContentsquareExperiment(
    EXPERIMENT_NAME_CONTACT_PAGE_ACCOUNT_MANAGEMENT_DIALOG,
  )

  if (selectedContent) {
    return selectedContent
  }

  return (
    <Dialog onClose={dialogControls.handleClose} open={dialogControls.isOpen}>
      <DialogTitle onClose={dialogControls.handleClose}>
        <FormattedMessage id="helpCenter.accountManagement.dialog.title.new" />
      </DialogTitle>
      <DialogContent className="tablet:max-w-lg">
        <DynamicAccountManagementDialogContent />
      </DialogContent>
    </Dialog>
  )
}
